import styled, { css } from "styled-components";
import {
  SimpleTableHead,
  SimpleTableRow,
  SimpleTableContainer,
  SimpleTableWrapper,
  SimpleTableToolbar,
  SearchInput,
  Pagination,
  RdsAgGridWrapper,
} from "@cdkglobal/radial";

export const zebra = css`
  tr:nth-of-type(even) {
    background-color: ${({ theme }) =>
      theme.color.zebraStripe.background.value};
    border-top: 1px solid ${({ theme }) => theme.color.gray[200].value};
    :hover {
      background-color: ${({ theme }) => theme.color.zebraStripe.hover.value};
    }
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const stickyHeader = css`
  thead {
    background: ${({ theme }) => theme.color.additional.light.value};
    position: sticky;
    top: 0;
    font-size: 13px;
  }
`;

export const radial = css`
  td {
    padding-top: 8px;
    font-size: 14px;
  }
`;

export const StyledBaseSimpleTable = styled.div`
  ${stickyHeader}
  ${radial}
  ${zebra}
  height: 90%; /* adjust for your needs */
`;

export const StyledIllustrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 8rem;
`;

export const StickySimpleTableContainer = styled(SimpleTableContainer)`
  height: calc(60vh);
  overflow: auto;
  scrollbar-width: thin;
`;

export const HighlightedSpan = styled.span`
  background-color: #ffee72;
  color: ${({ theme }) => theme.color.additional.alwaysBlack.value};
`;

export const StyledSimpleTableWrapper = styled(SimpleTableWrapper)`
  position: absolute;
  width: 100%;
`;

export const StyledSimpleTableToolbar = styled(SimpleTableToolbar)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSimpleTableToolbarItems = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const StyledSearchInput = styled(SearchInput)`
  box-shadow: none;
  width: 500px;
`;

export const StyledToolbarButtons = styled.div`
  display: flex;
  flex-start: left;
  gap: 1rem;
`;

export const StyledSimpleTableHeader = styled(SimpleTableHead)`
  z-index: 20;
`;

export const StyledCleanTableRow = styled(SimpleTableRow)`
  border: none;
  &:hover {
    background-color: inherit;
    box-shadow: none;
  }
`;

export const StyledPagination = styled(Pagination)`
  padding: 0rem;
  margin-top: 4rem;
`;

export const StyledRdsAgGridWrapper = styled(RdsAgGridWrapper)`
  .ag-icon {
    font-family: agGridBalham;
  }
  height: auto;
`;
